import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AuthService from "../../services/AuthService";
import Logger from "../../services/Logger";
import { Box, CircularProgress, Typography } from "@mui/material";

/**
 * Protects routes that require a logged-in user.
 * Redirects to /login if not authenticated.
 */
export function RequireUserAuth({ children }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const authStatus = await AuthService.isAuthenticated();
                setIsAuthenticated(authStatus);

                if (!authStatus) {
                    navigate("/login", {
                        state: { from: location.pathname },
                        replace: true
                    });
                }
            } catch (error) {
                Logger.error("Error checking authentication:", error);
                setIsAuthenticated(false);
                navigate("/login", {
                    state: { from: location.pathname },
                    replace: true
                });
            } finally {
                setIsLoading(false);
            }
        };

        checkAuth();
    }, [navigate, location.pathname]);

    if (isLoading) {
        return (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "400px", gap: 2 }}>
                <CircularProgress />
                <Typography variant="body2" color="text.secondary">
                    Checking authentication...
                </Typography>
            </Box>
        );
    }

    if (!isAuthenticated) {
        return null;
    }

    return children;
}
